module.exports = __webpack_public_path__ + "505d577817b42e3670b84996a50d27ed.png";